module.exports = __webpack_public_path__ + "static/img/sustainability_program_01.18a6ab8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/sustainability_program_01.jpg
// module id = k0D3
// module chunks = 0